import type { Release } from "api/dashboardBackend";
import imageGreenLight from "images/greenLight.svg";
import iconInfo from "images/icon-info.svg";
import imageRedLight from "images/redLight.svg";
import imageYellowLight from "images/yellowLight.svg";
import { compareVersionStrings } from "util/version";

export const groupReleasesForCards = (releases: Release[]): Release[][] => {
  const groups = new Map<string, Release[]>();
  const newestFirst = [...releases].sort(
    (a, b) =>
      compareVersionStrings(b.majorMinor, a.majorMinor) || b.patch - a.patch,
  );
  for (const release of newestFirst) {
    const existing = groups.get(release.majorMinor);
    if (existing) {
      existing.push(release);
    } else {
      groups.set(release.majorMinor, [release]);
    }
  }
  return Array.from(groups.values());
};

// The board layout has room for exactly 3 cards per platform
export const MAX_CARDS_PER_PLATFORM = 3;

export const selectCardGroups = (groups: Release[][]): Release[][] =>
  groups.slice(0, MAX_CARDS_PER_PLATFORM);

export const getReadinessStatus = (release: Release) => {
  const imageStatus =
    release.readinessStatus === "go"
      ? imageGreenLight
      : release.readinessStatus === "wait"
        ? imageYellowLight
        : release.readinessStatus === "stop"
          ? imageRedLight
          : iconInfo;
  const title =
    release.readinessStatus === "go"
      ? "Safe to proceed! "
      : release.readinessStatus === "wait"
        ? "Might be OK to proceed, but check with your #pd- channel first. "
        : release.readinessStatus === "stop"
          ? "Dangerous to proceed! Release should be paused if rolling out already. "
          : "";
  return { imageStatus, title };
};
